import React from 'react'
import { dark, type } from './tokens'
import { usePacketFonts } from './usePacketFonts'

export function PresentSprintPacket() {
  usePacketFonts()
  return (
    <div
      style={{
        background: dark.bg,
        color: dark.text,
        minHeight: '100vh',
        fontFamily: type.family.sans,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 48,
      }}
    >
      <div style={{ maxWidth: 720, textAlign: 'center' }}>
        <div
          style={{
            fontFamily: type.family.mono,
            fontSize: type.size.eyebrow,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: dark.textFaint,
            marginBottom: 16,
          }}
        >
          Sprint Packet — Present mode
        </div>
        <h1
          style={{
            fontFamily: type.family.serif,
            fontSize: type.size.hero,
            fontWeight: type.weight.regular,
            lineHeight: 1.05,
            margin: 0,
            color: dark.text,
          }}
        >
          Coming in <em style={{ color: dark.accent, fontStyle: 'italic' }}>v0.14</em>
        </h1>
      </div>
    </div>
  )
}
